import { useState } from 'react';

function App() {
  const [sessionInfo, setSessionInfo] = useState(null);

  const handleButton = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/loggedin`, {
        method: 'POST',
        credentials: 'include', // This is crucial for sending cookies
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({})
      });
      
      const data = await response.json();
      console.log("Response:", data);
      setSessionInfo(data);
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const checkSessionStatus = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/session-status`, {
        method: 'GET',
        credentials: 'include',
      });
      
      const data = await response.json();
      console.log("Session status:", data);
      setSessionInfo(data);
    } catch (error) {
      console.error("Error checking session:", error);
    }
  };

  return (
    <div style={{marginTop: '20vh', textAlign: 'center'}}>
      <button 
        style={{display: 'block', margin: '10px auto', padding: '10px 20px'}} 
        onClick={handleButton}
      >
        Set User Session
      </button>
      
      <button 
        style={{display: 'block', margin: '10px auto', padding: '10px 20px'}} 
        onClick={checkSessionStatus}
      >
        Check Session Status
      </button>
      
      {sessionInfo && (
        <div style={{marginTop: '20px', padding: '10px', border: '1px solid #ccc'}}>
          <h3>Session Info:</h3>
          <pre>{JSON.stringify(sessionInfo, null, 2)}</pre>
        </div>
      )}
    </div>
  );
}

export default App;